import { useTranslation } from "react-i18next";
import { ContentPanel, PageBanner, UnorderedList } from "../components";
import { TelemedicineServicesBanner } from "../images";
import { ContactUsButton } from "../components/ContactUsButton/ContactUsButton";

export const TelemedicineServices = () => {
    const { t } = useTranslation();
    const keyFeatures = t('telemedicineServices.keyFeatures', { returnObjects: true }) as string[]

    return (
        <div>
            <PageBanner image={TelemedicineServicesBanner} title={t('telemedicineServices.bannerTitle')} />

            <ContentPanel headerText={t('telemedicineServices.header')}>
                <p className="mb-5">{t('telemedicineServices.paragraph1')}</p>

                <h4 className="text-xl mb-5">{t('telemedicineServices.subHeader')}</h4>

                <p className="mb-5">{t('telemedicineServices.paragraph2')}</p>

                <h4 className="text-xl mb-5">{t('telemedicineServices.keyFeaturesAndBenefits')}</h4>

                <UnorderedList items={keyFeatures} hasCheckmark={false} />

                <p className="my-5">{t('telemedicineServices.idealFor')}</p>

                <ContactUsButton title={t('telemedicineServices.contactUsTitle')} />
            </ContentPanel>
        </div>
    )
}